import { Stack, Button, Card } from "react-bootstrap";
import { formatRut } from "../../validations/format";
import { useNavigate } from "react-router-dom";
import Flag from "./Flag";
import Motivo from "./Motivo";

const styles = {
  card: (siguiente) => ({
    padding: "1rem",
    flex: 1,
    minHeight: "180px",
    backgroundColor: siguiente ? undefined : "var(--color-gray)",
  }),
  button: {
    backgroundColor: "var(--color-green)",
    color: "var(--color-text)",
    border: "none",
    boxShadow: "none",
    outline: "none",
    marginLeft: "0.25rem",
  },
  badge: {
    fontWeight: 400,
    backgroundColor: "var(--color-accent)",
    color: "var(--color-background)",
  },
  textMuted: { color: "#6c757d" },
};

function AtencionSiguiente({ siguiente, actual, onAtender }) {
  const navigate = useNavigate();
  const handleVerFicha = () => {
    navigate(`/atencion/ficha/${siguiente.solicitante.idS}`);
  };

  // Si no hay siguiente o no tiene solicitante, mostrar mensaje
  const hasSiguiente = siguiente && siguiente.solicitante;

  if (!hasSiguiente) {
    return (
      <Card style={styles.card(false)} className="h-100">
        <p className="mb-2 h5">Siguiente</p>
        <p style={styles.textMuted}>No hay atenciones pendientes</p>
      </Card>
    );
  }

  const displayRut = siguiente.solicitante
    ? siguiente.solicitante.pasaporte
      ? siguiente.solicitante.rut
      : formatRut(siguiente.solicitante.rut)
    : "";

  return (
    <Card
      style={styles.card(siguiente && siguiente.solicitante)}
      className="h-100"
    >
      <p className="mb-2 h5">Siguiente</p>
      <Stack gap={2}>
        <Stack direction="horizontal" gap={1}>
          <Flag
            key={siguiente?.solicitante.flag} // Forzar re-render al cambiar flag desde el GET externo
            idSolicitante={siguiente?.solicitante.idS}
            initialFlag={siguiente?.solicitante.flag}
            size={25}
          />
          <strong>{siguiente?.solicitante.nombre}</strong>
        </Stack>
        {siguiente?.numero_ticket && (
      <p className="mb-0">
        <strong>Número:</strong> {siguiente.numero_ticket}
      </p>)}
        <p>
          <strong>{displayRut}</strong> - {siguiente?.motivo.nombre}
        </p>
        <Stack direction="horizontal" gap={2}>
          <Button className="btn-primary-blue" onClick={handleVerFicha}>
            Ver ficha
          </Button>
          <Button
            className="ms-auto"
            variant="success"
            onClick={() => {
              if (siguiente && siguiente.ticket_id) {
                onAtender(siguiente.ticket_id, siguiente.solicitante.idS);
              }
            }}
            disabled={!!(actual && actual.atencion)}
          >
            Atender
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}

export default AtencionSiguiente;
